/**
 * Escapes special regex characters in a string to prevent ReDoS attacks
 * @param str - The string to escape
 * @returns The escaped string safe for use in RegExp constructor
 */
export function escapeRegex(str: string | null | undefined): string {
  if (str == null) {
    return "";
  }

  const stringValue = String(str);

  if (stringValue === "") {
    return "";
  }

  // Escape all special regex characters: [ ] { } ( ) * + ? . \ ^ $ |
  return stringValue.replace(/[[\]{}()*+?.\\/^$|]/g, "\\$&");
}
